export const AI_FIELD_NAVIGATION_ATTRIBUTES = 'data-ai-field-id';
